import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Interceptor class for adding the JWT Authorization header to all the requests made to the API.
 */

@Injectable()
export class AuthorizationHeaderInterceptor implements HttpInterceptor {
    readonly AUTHORIZATION_HEADER = 'Authorization';
    readonly X_CORRELATION_ID = "X-Correlation-ID";
    readonly ACCEPT_LANGUAGE = "Accept-Language";


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Skip if Authorization header is already set (e.g., MSAL token exchange)
        const existingAuth = req.headers.get(this.AUTHORIZATION_HEADER);
        const userToken = localStorage.getItem('user_token');

        let headers = req.headers;

        // Only set Authorization if not already present and user_token exists
        if (!existingAuth && userToken) {
            headers = headers.set(this.AUTHORIZATION_HEADER, 'Bearer ' + userToken);
        }

        headers = headers.set(this.X_CORRELATION_ID, this.getRandom(6).toString());
        headers = headers.set(this.ACCEPT_LANGUAGE, this.getLocalLanguage());

        const clonedRequest = req.clone({
            headers: headers
        });

        return next.handle(clonedRequest);
    }

    getRandom(length) {
        return Math.floor(Math.pow(10, length - 1) + Math.random() * 9 * Math.pow(10, length - 1));
    }

    getLocalLanguage() {
        const selectedLanguage = localStorage.getItem('user-language');
        switch (selectedLanguage) {
            case "en":
                return "en-US";
            default:
                return "ro-RO";
        }
    }
}
